import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueService } from '../services/issue.service';

@Pipe({
  name: 'issueCategory'
})
export class IssueCategoryPipe implements PipeTransform {

  constructor(private _issueService: IssueService){

  }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return null;
    return this._issueService.getAllIssueCategories(true).pipe(map(x => x.find(y => y.categoryid === value))).pipe(map(x => x? x.categoryname: null));
  }

}
